<template>
    <div class="sidebar-wrapper" :class="{'hide': isClosed}">

        <span v-if="!isClosed" class="sidebar-toggle" @click="toggleBar()">hide menu</span>
        <span v-else class="sidebar-toggle hide" @click="toggleBar()">show menu</span>

        <div class="sidebar" :class="{'hide': isClosed}">
            <div class="sidebar-inner">

                <div class="sidebar-list primary">
                    <p class="sidebar-list-item">
                       <router-link to="/users" :class="{'router-link-active': $route.name === 'users'}">
                         <span>Users</span>
                       </router-link>
                    </p>
                    <p class="sidebar-list-item">
                      <router-link to="/orders" :class="{'router-link-active': $route.name === 'orders'}">
                        <span>Orders</span>
                      </router-link>
                    </p>
                    <p class="sidebar-list-item">
                      <router-link to="/settings" :class="{'router-link-active': $route.name === 'settings'}">
                        <span>Settings</span>
                      </router-link>
                    </p>
                    <p class="sidebar-list-item" v-if="this.$hasRole(['admin'])">
                      <router-link to="/addresses" :class="{'router-link-active': $route.name === 'addresses'}">
                        <span>Addresses</span>
                      </router-link>
                    </p>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'AdminSidebar',
  data () {
    return {
      isClosed: false,
      windowWidth: 0
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize () {
      this.windowWidth = window.innerWidth
    },
    toggleBar () {
      this.isClosed = !this.isClosed
    }
  }
}
</script>
